<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
    const cartBubbles = document.querySelectorAll('.cart-count-bubble');

    function updateCartBubble(cartBubble) {
        const textContent = cartBubble.querySelector('span.text').textContent.trim();
        if (textContent === "0" || textContent === "") {
            cartBubble.style.setProperty('display', 'none', 'important');
        } else {
            cartBubble.style.removeProperty('display');
        }
    }

    cartBubbles.forEach(cartBubble => updateCartBubble(cartBubble));

    cartBubbles.forEach(cartBubble => {
        const observer = new MutationObserver(() => updateCartBubble(cartBubble));
        observer.observe(cartBubble.querySelector('span.text'), {characterData: true, subtree: true, childList: true});
    });
});
